import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlice: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slice, knife"><path d="M2.75 6.75L5.75 3.75L21.25 19.25C15.0833 20.8 10.9722 21.2789 4.80556 15.0922L8 11.9989L2.75 6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlice;
